import React from "react";
import VideoGallery from "../components/LabInAction/VideoGallery";

const LabInAction = () => {
  return (
    <div className="bg-gray-50 text-gray-900">

      <VideoGallery/>

    </div>
  );
};

export default LabInAction;
